import React from 'react';
import { motion } from 'framer-motion';
import { Flame, ChevronDown, Sparkles } from 'lucide-react';
export function NewHero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black pt-14 sm:pt-16" data-id="element-595" data-mp="1my1wh4895iey">
      {/* Enhanced atmospheric background with more depth */}
      <div className="absolute inset-0 bg-gradient-radial from-slate-900 via-black to-black" data-id="element-596" data-mp="1wy2gythuy4kq" />

      {/* Layered scientific color fields */}
      <div className="absolute top-1/4 left-1/4 w-[600px] h-[600px] bg-amber-600/15 rounded-full blur-3xl animate-flicker" data-id="element-597" data-mp="194tz0vxhpspc" />
      <div className="absolute bottom-1/3 right-1/4 w-[600px] h-[600px] bg-cyan-600/10 rounded-full blur-3xl animate-flicker-delayed" data-id="element-598" data-mp="1ixhxrw8166qp" />

      {/* Additional ambient depth */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-purple-600/10 rounded-full blur-3xl animate-pulse-slow" data-id="element-599" data-mp="1e4f3flvfit9g" />

      {/* Vignette for focus */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/60 pointer-events-none" data-id="element-600" data-mp="lfrjpuqbwby0" />

      {/* MONUMENTAL BACKGROUND LOGO - Your actual PSI logo as powerful presence */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 3,
      delay: 0.5
    }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none" style={{
      width: '100vh',
      height: '100vh' // Mobile default
    }} data-id="element-601" data-mp="1uimbz3e4ksp5">
        {/* Responsive width override */}
        <style data-id="element-602" data-mp="1buhbq5wofpv3">{`
        @media (min-width: 768px) {
          .hero-logo-container {
            width: 180vh !important;
            height: 180vh !important;
          }
        }
      `}</style>
        {/* PSI Logo - Rotating slowly with perfect opacity */}
        <motion.div className="w-full h-full flex items-center justify-center hero-logo-container" animate={{
        rotate: [0, 360]
      }} transition={{
        duration: 180,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-603" data-mp="2s4tfsb2luh0g">
          <img src="https://cdn.magicpatterns.com/uploads/jToXSpcV6pHGAAwW9hQchh/PeptideScienceInstituteLogo2-Transparent.png" alt="PSI Logo" className="w-full h-full object-contain" style={{
          opacity: 0.06,
          filter: 'blur(1px)'
        }} data-id="element-604" data-mp="2cfnct78crgey" />
        </motion.div>

        {/* Subtle glow effect around the logo */}
        <motion.div className="absolute inset-0 bg-gradient-radial from-purple-600/20 via-cyan-500/10 to-transparent blur-3xl motion-reduce:animate-none" animate={{
        opacity: [0.45, 0.7, 0.45],
        scale: [1, 1.03, 1]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-605" data-mp="1tivmidue811e" />
      </motion.div>

      {/* Enhanced floating candles - more of them with varied timing */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 2,
      delay: 0.8
    }} className="absolute top-32 left-16 hidden lg:flex flex-col items-center" data-id="element-606" data-mp="3chjpr1ztabhc">
        <Flame className="w-7 h-7 text-amber-500 animate-flicker" data-id="element-607" data-mp="3qgjgcf6vx0g5" />
        <div className="w-1 h-20 bg-gradient-to-b from-amber-900/60 to-transparent" data-id="element-608" data-mp="3vfctg6i9epfs" />
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 2,
      delay: 1.0
    }} className="absolute top-32 right-16 hidden lg:flex flex-col items-center" data-id="element-609" data-mp="3hg3h5hx6cfh3">
        <Flame className="w-7 h-7 text-amber-500 animate-flicker-delayed" data-id="element-610" data-mp="2a20bco3hmgwa" />
        <div className="w-1 h-20 bg-gradient-to-b from-amber-900/60 to-transparent" data-id="element-611" data-mp="2q8wg9z6c2nvw" />
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 2,
      delay: 0.9
    }} className="absolute top-1/3 left-32 hidden xl:flex flex-col items-center" data-id="element-612" data-mp="2lig38g6fd4a2">
        <Flame className="w-6 h-6 text-amber-500 animate-flicker" style={{
        animationDelay: '0.3s'
      }} data-id="element-613" data-mp="397qth3q5fg9y" />
        <div className="w-1 h-16 bg-gradient-to-b from-amber-900/50 to-transparent" data-id="element-614" data-mp="34977x4fgw6i4" />
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 2,
      delay: 1.1
    }} className="absolute top-1/3 right-32 hidden xl:flex flex-col items-center" data-id="element-615" data-mp="2z800j6h8l9bz">
        <Flame className="w-6 h-6 text-amber-500 animate-flicker-delayed" style={{
        animationDelay: '0.5s'
      }} data-id="element-616" data-mp="1js142sgzf1rk" />
        <div className="w-1 h-16 bg-gradient-to-b from-amber-900/50 to-transparent" data-id="element-617" data-mp="3bvfq1xo8ee3" />
      </motion.div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-5 sm:px-6 text-center py-12 sm:py-16 md:py-20" data-id="element-618" data-mp="8aoj31j8up0j">
        {/* Trust badge text above pre-headline */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        type: 'spring'
      }} className="flex justify-center mb-4" data-id="element-619" data-mp="i19ob7tfarsf">
          <div className="relative px-4 py-2 border border-stone-500/40 rounded-md" data-id="element-620" data-mp="w0iwplbe0hlu">
            <p className="relative text-xs sm:text-sm tracking-[0.15em] uppercase font-medium text-stone-300" style={{
            fontFamily: 'system-ui, -apple-system, sans-serif',
            letterSpacing: '0.15em'
          }} data-id="element-621" data-mp="2sumb0re8c7sh">
              Trusted by Over 1,000+ Doctors, Biohackers, Researchers, Coaches,
              Health Enthusiasts & Professionals
            </p>
          </div>
        </motion.div>

        {/* Pre-headline - Enhanced */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mb-6 sm:mb-8 md:mb-10" data-id="element-622" data-mp="8xz725e1t44p">
          <motion.p className="text-sm sm:text-base md:text-lg tracking-[0.2em] sm:tracking-[0.3em] uppercase font-bold" animate={{
          textShadow: ['0 0 20px rgba(217, 119, 6, 0.4)', '0 0 30px rgba(217, 119, 6, 0.6)', '0 0 20px rgba(217, 119, 6, 0.4)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} style={{
          color: '#f59e0b'
        }} data-id="element-623" data-mp="wr7l3rvaovut">
            The PSI PRO Monthly Membership
          </motion.p>
        </motion.div>

        {/* Main headline - DRAMATICALLY ENHANCED */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mb-8 sm:mb-10" data-id="element-624" data-mp="12ji4xq13twhk">
          <motion.h1 initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 1.2,
          type: 'spring',
          stiffness: 100
        }} className="font-bold leading-tight" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-625" data-mp="xk5kfbxph1i5">
            {/* Line 1: Join the - SMALL intro */}
            <motion.div className="text-2xl md:text-3xl mb-4 md:mb-6" style={{
            color: '#fbbf24'
          }} data-id="element-626" data-mp="u29hl2wtyq7e">
              <span className="inline-block bg-gradient-to-r from-amber-400 via-amber-200 to-stone-200 bg-clip-text text-transparent" style={{
              backgroundSize: '200% 100%',
              textShadow: '0 0 60px rgba(217, 119, 6, 0.3), 0 0 30px rgba(217, 119, 6, 0.2)',
              filter: 'drop-shadow(0 0 20px rgba(251, 191, 36, 0.25))'
            }} data-id="element-627" data-mp="l34fxnpz2gr0">
                Join the
              </span>
            </motion.div>

            {/* Line 2: PRIVATE RESEARCH ORDER - LARGEST with boxes */}
            <motion.div className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl mb-4 md:mb-6" data-id="element-628" data-mp="2916n13eb1k9b">
              <span className="relative inline-block px-4 sm:px-8 py-3 mx-1 sm:mx-3" data-id="element-629" data-mp="2d1h2d6nzln0u">
                {/* Corner ornaments */}
                <span className="absolute -top-1 -left-1 w-5 h-5 border-l-2 border-t-2 border-amber-400/70 z-0" style={{
                boxShadow: '0 0 8px rgba(251, 191, 36, 0.3)'
              }} data-id="element-630" data-mp="2i1uzhto1vck3" />
                <span className="absolute -top-1 -right-1 w-5 h-5 border-r-2 border-t-2 border-cyan-400/70 z-0" style={{
                boxShadow: '0 0 8px rgba(34, 211, 238, 0.35)'
              }} data-id="element-631" data-mp="1ub7noxb0k2s9" />
                <span className="absolute -bottom-1 -left-1 w-5 h-5 border-l-2 border-b-2 border-purple-400/70 z-0" style={{
                boxShadow: '0 0 8px rgba(192, 132, 252, 0.35)'
              }} data-id="element-632" data-mp="243di0doqmwam" />
                <span className="absolute -bottom-1 -right-1 w-5 h-5 border-r-2 border-b-2 border-amber-400/70 z-0" style={{
                boxShadow: '0 0 8px rgba(251, 191, 36, 0.3)'
              }} data-id="element-633" data-mp="1yy7q6z5beyl1" />

                <span className="relative z-10" style={{
                color: '#fbbf24',
                textShadow: '0 0 30px rgba(251, 191, 36, 0.4)'
              }} data-id="element-634" data-mp="2dwjjcvthbp7g">
                  PRIVATE RESEARCH ORDER
                </span>
              </span>
            </motion.div>

            {/* Line 3: That controls human biology - MEDIUM */}
            <motion.div className="text-xl sm:text-2xl md:text-3xl lg:text-4xl mb-3 md:mb-4" style={{
            color: '#fbbf24'
          }} data-id="element-635" data-mp="1uy7brei7undz">
              <span className="inline-block bg-gradient-to-r from-amber-400 via-amber-200 to-stone-200 bg-clip-text text-transparent" style={{
              backgroundSize: '200% 100%',
              textShadow: '0 0 60px rgba(217, 119, 6, 0.3), 0 0 30px rgba(217, 119, 6, 0.2)',
              filter: 'drop-shadow(0 0 20px rgba(251, 191, 36, 0.25))'
            }} data-id="element-636" data-mp="12g1sdb8nies7">
                That controls human biology
              </span>
            </motion.div>

            {/* Line 4: AT THE HIGHEST LEVELS - LARGE with underline */}
            <motion.div className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl" data-id="element-637" data-mp="2s0qotpkr1ge7">
              <span className="relative inline-block bg-gradient-to-r from-amber-400 via-amber-200 to-stone-200 bg-clip-text text-transparent" style={{
              borderBottom: '3px solid rgba(251, 191, 36, 0.9)',
              paddingBottom: '4px',
              filter: 'none',
              textShadow: 'none'
            }} data-id="element-638" data-mp="2nz5by487t240">
                AT THE HIGHEST LEVELS
              </span>
            </motion.div>
          </motion.h1>

          {/* Subheadline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 1.6
        }} className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-stone-300 font-bold leading-relaxed mt-8 sm:mt-10 md:mt-12" style={{
          textShadow: '0 0 20px rgba(217, 119, 6, 0.2)'
        }} data-id="element-639" data-mp="24fgcm97piiey">
            And Discover How to Optimize Health & Performance Beyond What 99% of
            Doctors Even Know is Possible
          </motion.p>
        </motion.div>

        {/* DNA Helix Divider - Scientific but mystical */}
        <motion.div initial={{
        opacity: 0,
        scale: 0
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 2.2
      }} className="flex items-center justify-center gap-4 mb-8 sm:mb-12" data-id="element-640" data-mp="35vnwmqx3fhnh">
          <motion.div className="w-32 h-px bg-gradient-to-r from-transparent via-cyan-500 to-purple-500" animate={{
          opacity: [0.5, 1, 0.5]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-641" data-mp="1481fdkcuoelu" />
          <motion.div animate={{
          rotate: 360
        }} transition={{
          duration: 20,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-642" data-mp="lg08pvtu3k1v">
            <svg width="24" height="24" viewBox="0 0 24 24" className="text-cyan-400" data-id="element-643" data-mp="1wtb26is23ex8">
              <circle cx="12" cy="6" r="2" fill="currentColor" opacity="0.8" data-id="element-644" data-mp="1ep6cpu2l96h" />
              <circle cx="12" cy="12" r="2" fill="currentColor" data-id="element-645" data-mp="1gs6i2oxsiox" />
              <circle cx="12" cy="18" r="2" fill="currentColor" opacity="0.8" data-id="element-646" data-mp="6ebkr2lmwvgv" />
              <path d="M12 6 L12 18" stroke="currentColor" strokeWidth="1" opacity="0.4" data-id="element-647" data-mp="aeubetbsjvhh" />
            </svg>
          </motion.div>
          <motion.div className="w-32 h-px bg-gradient-to-l from-transparent via-purple-500 to-cyan-500" animate={{
          opacity: [0.5, 1, 0.5]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-648" data-mp="kc8l8a37lm0t" />
        </motion.div>

        {/* Target audience - Enhanced with better breaks and emphasis */}
        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 2.6
      }} className="text-lg sm:text-xl md:text-2xl text-stone-300 mb-10 sm:mb-16 leading-relaxed max-w-5xl mx-auto" data-id="element-649" data-mp="131okyv72lag6">
          If you're a doctor, clinician, coach, practitioner,
          <br data-id="element-650" data-mp="147tbrqzc01tn" />
          or an advanced biohacker ready to gain{' '}
          <span className="font-bold text-emerald-300 px-2 py-1 border border-emerald-500/40 bg-emerald-950/30 rounded" style={{
          textShadow: '0 0 20px rgba(52, 211, 153, 0.4)'
        }} data-id="element-651" data-mp="20xaq0ucdqw6y">
            REAL control
          </span>{' '}
          of human biology
          <br data-id="element-652" data-mp="1n65p7ox9zxv1" />
          (for yourself or for others)...
        </motion.p>

        {/* DRAMATIC PAUSE - then the hook (NO BOX, NO BREATHING) */}
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 3.5,
        type: 'spring',
        stiffness: 80
      }} className="mb-8 sm:mb-12 relative" data-id="element-653" data-mp="2jpcy3hayh45l">
          {/* Dramatic spotlight effect behind text */}
          <motion.div className="absolute inset-0 -inset-x-8 sm:-inset-x-20 bg-gradient-radial from-amber-600/20 via-amber-600/5 to-transparent blur-2xl sm:blur-3xl" animate={{
          opacity: [0.3, 0.6, 0.3],
          scale: [1, 1.1, 1]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-654" data-mp="37vr2n2912im" />

          {/* Subtle particle effects around the text */}
          <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-655" data-mp="3lh63qck6w56i">
            {[...Array(6)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-amber-400 rounded-full" style={{
            left: `${20 + i * 15}%`,
            top: '50%'
          }} animate={{
            y: [-20, -40, -20],
            opacity: [0, 1, 0]
          }} transition={{
            duration: 3,
            repeat: Infinity,
            delay: i * 0.5,
            ease: 'easeInOut'
          }} data-id="element-656" data-mp="1jnq3cnyavbyc" data-mpi={i} />)}
          </div>

          <div className="relative text-center max-w-4xl mx-auto space-y-2 sm:space-y-4" data-id="element-657" data-mp="3iv6r6k1ejkfb">
            <motion.p className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold" style={{
            background: 'linear-gradient(to right, #fbbf24, #f59e0b, #fbbf24)',
            backgroundSize: '200% 100%',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            filter: 'drop-shadow(0 0 40px rgba(251, 191, 36, 0.4))'
          }} animate={{
            backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
          }} transition={{
            duration: 8,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-658" data-mp="pa6r9yeval5">
              This could be the
            </motion.p>

            <motion.p className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-amber-400" style={{
            textShadow: '0 0 60px rgba(251, 191, 36, 0.6)'
          }} data-id="element-659" data-mp="sq2acajjzwai">
              most life-changing opportunity
              <br data-id="element-660" data-mp="17mjk4xc3h2uy" />
              you ever get
            </motion.p>
          </div>

          {/* Subtle underline accent */}
          <motion.div className="mx-auto mt-6 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent" style={{
          width: '60%'
        }} initial={{
          scaleX: 0
        }} animate={{
          scaleX: 1
        }} transition={{
          duration: 1,
          delay: 4,
          ease: 'easeOut'
        }} data-id="element-661" data-mp="2e1twq009yfuk" />

          {/* Important note */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 4.2
        }} className="text-base sm:text-lg md:text-xl text-white mt-8 max-w-3xl mx-auto leading-relaxed" data-id="element-662" data-mp="3ovw9rc9hcu4n">
            PLEASE NOTE: The Private Research Order is not for "normal" people.
            This is for those ready to access the deepest secrets of health,
            performance, and regeneration beyond anything else you've seen.
          </motion.p>
        </motion.div>

        {/* TESTIMONIALS SECTION - Supporting Claims */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 4.2
      }} className="mt-12 sm:mt-20 mb-10 sm:mb-16 max-w-4xl mx-auto" data-id="element-663" data-mp="1vyf3qt23dvp9">
          {/* Section intro - Purple accent */}
          <div className="text-center mb-10 sm:mb-16" data-id="element-664" data-mp="1d98dmkyyy1tf">
            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 4.4
          }} className="text-purple-400 text-lg sm:text-xl font-semibold mb-3" style={{
            textShadow: '0 0 20px rgba(192, 132, 252, 0.3)'
          }} data-id="element-665" data-mp="189ng8ezg61it">
              Real Results From Real Clients & Customers
            </motion.p>
            <motion.div className="w-32 h-1 bg-gradient-to-r from-transparent via-purple-500 to-transparent mx-auto" initial={{
            scaleX: 0
          }} animate={{
            scaleX: 1
          }} transition={{
            duration: 0.8,
            delay: 4.6
          }} data-id="element-666" data-mp="315g6t6ag6dh5" />
          </div>

          {/* Testimonials - Single Column, Stacked */}
          <div className="space-y-10 sm:space-y-16" data-id="element-667" data-mp="2m8pax6zzfjwa">
            {/* Testimonial 1 - Sean L. */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 4.7
          }} className="relative" data-id="element-668" data-mp="2r8bjv48s2dza">
              {/* Subtle background glow - purple tint */}
              <div className="absolute inset-0 bg-gradient-radial from-purple-600/5 via-transparent to-transparent blur-2xl" data-id="element-669" data-mp="3hx4qv6kzxonv" />

              <div className="relative px-4 sm:px-8 py-8 sm:py-10" data-id="element-670" data-mp="3cyjszdt7vh2l">
                {/* Profile Image */}
                <div className="flex justify-center mb-6" data-id="element-671" data-mp="3rvkh77c78twb">
                  <div className="relative" data-id="element-672" data-mp="3mwzen19h5y4p">
                    <div className="absolute inset-0 bg-purple-500/20 blur-xl rounded-full" data-id="element-673" data-mp="3mv67zlyv3dwp" />
                    <img src="https://cdn.magicpatterns.com/uploads/8TaJVJxgg4BMR3q5DqSNsr/SeanL.jpg" alt="Sean L." className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-purple-500/40 shadow-[0_0_30px_rgba(168,85,247,0.3)]" data-id="element-674" data-mp="2z5kb555yparv" />
                  </div>
                </div>

                {/* Large opening quote - purple */}
                <div className="mb-4 sm:mb-6" data-id="element-675" data-mp="2bilzqlwp8t0t">
                  <span className="text-purple-500/40 text-5xl sm:text-7xl font-serif leading-none" data-id="element-676" data-mp="2bhu2l6ngen8f">
                    "
                  </span>
                </div>

                {/* TV Screen Frame around testimonial text */}
                <div className="relative mb-6 sm:mb-8 max-w-3xl" data-id="element-677" data-mp="h1vkebxbl3ir">
                  {/* Outer purple glow */}
                  <div className="absolute -inset-2 sm:-inset-4 bg-purple-500/10 blur-lg sm:blur-xl rounded-lg" data-id="element-678" data-mp="m0fa8nf1azge" />

                  {/* TV screen frame */}
                  <div className="relative border-2 border-purple-500/30 rounded-lg p-4 sm:p-6 bg-gradient-to-br from-purple-950/20 to-black/40 shadow-[0_0_20px_rgba(168,85,247,0.18),inset_0_0_20px_rgba(168,85,247,0.05)] sm:shadow-[0_0_30px_rgba(168,85,247,0.2),inset_0_0_20px_rgba(168,85,247,0.05)]" data-id="element-679" data-mp="19rcerf4i2uhm">
                    {/* Screen scanline effect (subtle) */}
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/5 to-transparent pointer-events-none rounded-lg" data-id="element-680" data-mp="3lf0t8meobe4f" />

                    {/* Testimonial text - with emphasis on key phrases */}
                    <p className="text-stone-300 text-base sm:text-lg md:text-xl leading-relaxed relative z-10" data-id="element-681" data-mp="9kqq54ovn6fm">
                      They're doing something{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-682" data-mp="3w01zc9zmkfbb">
                        revolutionary
                      </span>{' '}
                      here. You'll be getting something extremely personalized,
                      you'll be getting the care that you need, you'll be
                      getting the support you need, the multi-faceted support
                      you need, should you decide to work with the Peptide
                      Science Institute, both on the emotional front, mental
                      front, and on the medical front. Working with them is just
                      a fantastic experience and I highly recommend this to
                      anybody who's even considering, if you're looking for
                      something{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-683" data-mp="1eri7i6j8037m">
                        life-changing
                      </span>
                      , if you want to{' '}
                      <span className="text-white font-bold" data-id="element-684" data-mp="1nrna83dgydfg">
                        attack diseases that the mainstream says is not really
                        something treatable
                      </span>
                      ...{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-685" data-mp="1xgoqzvru8yuh">
                        it will blow your mind.
                      </span>{' '}
                      That's what I can guarantee.
                    </p>
                  </div>
                </div>

                {/* Attribution with client type */}
                <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-686" data-mp="2belr325i3ndw">
                  <div className="h-px w-full sm:w-auto sm:flex-1 bg-gradient-to-r from-purple-500/40 to-transparent" data-id="element-687" data-mp="c5oo4irfwmkc" />
                  <div className="text-center sm:text-right" data-id="element-688" data-mp="h4ruc6j5oytw">
                    <p className="text-purple-400 font-semibold text-base sm:text-lg mb-1" data-id="element-689" data-mp="1kenk17abuvto">
                      Sean L.
                    </p>
                    <p className="text-stone-500 text-sm" data-id="element-690" data-mp="1teiypm33d8yg">
                      Transformation Services Client
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Testimonial 2 - Wilfred A. */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 4.9
          }} className="relative" data-id="element-691" data-mp="23avtyoeabuvb">
              {/* Subtle background glow - purple tint */}
              <div className="absolute inset-0 bg-gradient-radial from-purple-600/5 via-transparent to-transparent blur-2xl" data-id="element-692" data-mp="2m0vfx2etwtui" />

              <div className="relative px-4 sm:px-8 py-8 sm:py-10" data-id="element-693" data-mp="30pdloifs7p8d">
                {/* Profile Image */}
                <div className="flex justify-center mb-6" data-id="element-694" data-mp="35p9pohohbgnx">
                  <div className="relative" data-id="element-695" data-mp="35mng6ci12r32">
                    <div className="absolute inset-0 bg-purple-500/20 blur-xl rounded-full" data-id="element-696" data-mp="2qqpe6dlfasix" />
                    <img src="https://cdn.magicpatterns.com/uploads/3sr1cDaEEULSv8K4Ew3yfQ/WilfredA.jpg" alt="Wilfred A." className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-purple-500/40 shadow-[0_0_30px_rgba(168,85,247,0.3)]" data-id="element-697" data-mp="2vq0u5kdyttzg" />
                  </div>
                </div>

                {/* Large opening quote - purple */}
                <div className="mb-4 sm:mb-6" data-id="element-698" data-mp="2cy80dnr2o4qo">
                  <span className="text-purple-500/40 text-5xl sm:text-7xl font-serif leading-none" data-id="element-699" data-mp="1z0b833jnikht">
                    "
                  </span>
                </div>

                {/* TV Screen Frame around testimonial text */}
                <div className="relative mb-6 sm:mb-8 max-w-3xl" data-id="element-700" data-mp="2jgw48wwhjq5j">
                  {/* Outer purple glow */}
                  <div className="absolute -inset-2 sm:-inset-4 bg-purple-500/10 blur-lg sm:blur-xl rounded-lg" data-id="element-701" data-mp="2eghth73i223t" />

                  {/* TV screen frame */}
                  <div className="relative border-2 border-purple-500/30 rounded-lg p-4 sm:p-6 bg-gradient-to-br from-purple-950/20 to-black/40 shadow-[0_0_20px_rgba(168,85,247,0.18),inset_0_0_20px_rgba(168,85,247,0.05)] sm:shadow-[0_0_30px_rgba(168,85,247,0.2),inset_0_0_20px_rgba(168,85,247,0.05)]" data-id="element-702" data-mp="24jd6x65qs4mh">
                    {/* Screen scanline effect (subtle) */}
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/5 to-transparent pointer-events-none rounded-lg" data-id="element-703" data-mp="1ltx6sjxyye6l" />

                    {/* Testimonial text - with emphasis on key phrases */}
                    <p className="text-stone-300 text-base sm:text-lg md:text-xl leading-relaxed relative z-10" data-id="element-704" data-mp="1csz0tw3yzwld">
                      I{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-705" data-mp="3oina10ra5kvm">
                        100% would put my name behind
                      </span>{' '}
                      Ali & Brenden. I've had other health coaches in the past
                      (most are MD's), and I must say, Brenden & Ali are{' '}
                      <span className="text-white font-bold" data-id="element-706" data-mp="68lb4r1mtwu4">
                        FAR more in depth, systems-oriented, and rigorous
                      </span>{' '}
                      than anything I've ever seen. Also I did grab that
                      peptides course. It has given me the knowledge to turn
                      familys' health conditions around even when the medical
                      system has failed them. I owe this to the lessons I've
                      acquired from Ali & Brenden. In terms of level of positive
                      impact on my life, they are likely in the{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-707" data-mp="20qrf4r8obzg4">
                        top 5 most important people I've ever met
                      </span>{' '}
                      as they have{' '}
                      <span className="text-white font-bold" data-id="element-708" data-mp="1rrcmbl51bcsg">
                        added many years to my life
                      </span>{' '}
                      and to those of my loved ones.
                    </p>
                  </div>
                </div>

                {/* Attribution with client type */}
                <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-709" data-mp="1ms9r0seuwkxo">
                  <div className="h-px w-full sm:w-auto sm:flex-1 bg-gradient-to-r from-purple-500/40 to-transparent" data-id="element-710" data-mp="183df2k9oinrs" />
                  <div className="text-center sm:text-right" data-id="element-711" data-mp="1d285a79z7elx">
                    <p className="text-purple-400 font-semibold text-base sm:text-lg mb-1" data-id="element-712" data-mp="z1dvplb6z7lo">
                      Wilfred A.
                    </p>
                    <p className="text-stone-500 text-sm" data-id="element-713" data-mp="14077n9atyqjq">
                      Peptide Mastery Owner & Transformation Services Client
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Testimonial 3 - Ronald R. */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 5.1
          }} className="relative" data-id="element-714" data-mp="thg81kdq9s7g">
              {/* Subtle background glow - purple tint */}
              <div className="absolute inset-0 bg-gradient-radial from-purple-600/5 via-transparent to-transparent blur-2xl" data-id="element-715" data-mp="1d5p3c3akieb6" />

              <div className="relative px-4 sm:px-8 py-8 sm:py-10" data-id="element-716" data-mp="1m411qrhoege6">
                {/* Large opening quote - purple */}
                <div className="mb-4 sm:mb-6" data-id="element-717" data-mp="1h6iowq0jfh0w">
                  <span className="text-purple-500/40 text-5xl sm:text-7xl font-serif leading-none" data-id="element-718" data-mp="1h3mqz1oowscg">
                    "
                  </span>
                </div>

                {/* TV Screen Frame around testimonial text */}
                <div className="relative mb-6 sm:mb-8 max-w-3xl" data-id="element-719" data-mp="ns80tmaiwiac">
                  {/* Outer purple glow */}
                  <div className="absolute -inset-2 sm:-inset-4 bg-purple-500/10 blur-lg sm:blur-xl rounded-lg" data-id="element-720" data-mp="skhvtgqhw8jh" />

                  {/* TV screen frame */}
                  <div className="relative border-2 border-purple-500/30 rounded-lg p-4 sm:p-6 bg-gradient-to-br from-purple-950/20 to-black/40 shadow-[0_0_20px_rgba(168,85,247,0.18),inset_0_0_20px_rgba(168,85,247,0.05)] sm:shadow-[0_0_30px_rgba(168,85,247,0.2),inset_0_0_20px_rgba(168,85,247,0.05)]" data-id="element-721" data-mp="xkxacbmijm31">
                    {/* Screen scanline effect (subtle) */}
                    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/5 to-transparent pointer-events-none rounded-lg" data-id="element-722" data-mp="399odrlag7y34" />

                    {/* Testimonial text - with emphasis on key phrases */}
                    <p className="text-stone-300 text-base sm:text-lg md:text-xl leading-relaxed relative z-10" data-id="element-723" data-mp="35s0qm40d9q0x">
                      I am a{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-724" data-mp="2w1eguqfbztq5">
                        physician with an integrative medicine practice
                      </span>{' '}
                      and your work has been{' '}
                      <span className="text-white font-bold" data-id="element-725" data-mp="3ooig0erqtdu0">
                        very valuable in treating my patients.
                      </span>{' '}
                      When I lecture to physicians I always mention "peptide
                      mastery" as a great source of material and{' '}
                      <span className="text-amber-400 font-semibold" data-id="element-726" data-mp="3aozkclg4buyl">
                        extensive references
                      </span>
                      ... It has been very helpful in my care of patients and I
                      appreciate the extensive references.
                    </p>
                  </div>
                </div>

                {/* Attribution with client type */}
                <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-727" data-mp="3rzl9z14cjf7i">
                  <div className="h-px w-full sm:w-auto sm:flex-1 bg-gradient-to-r from-purple-500/40 to-transparent" data-id="element-728" data-mp="3e7okz5xz5lfc" />
                  <div className="text-center sm:text-right" data-id="element-729" data-mp="3i5mbqd7e8fku">
                    <p className="text-purple-400 font-semibold text-base sm:text-lg mb-1" data-id="element-730" data-mp="9sylhgxfgc13">
                      Ronald R.
                    </p>
                    <p className="text-stone-500 text-sm" data-id="element-731" data-mp="eom8pqscmv3y">
                      Peptide Mastery Owner
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* MASSIVE BREATHING ROOM - Let the claim sink in */}

        {/* For The Ones Who Already Know - COMPLETELY REDESIGNED OFFER BOX */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 4.3
      }} className="mb-8 sm:mb-12 relative" data-id="element-732" data-mp="2qe6fdrg1behf">
          {/* Distinctive outer glow to separate from page */}
          <div className="absolute -inset-2 sm:-inset-4 bg-gradient-to-r from-amber-600/20 via-purple-600/20 to-cyan-600/20 blur-xl sm:blur-2xl rounded-lg" data-id="element-733" data-mp="2mzeo7sy8pl11" />

          {/* Main offer box with SIMPLE BLACK background */}
          <div className="relative p-5 sm:p-10 md:p-12 bg-black border-2 sm:border-4 border-amber-500/60 rounded-lg shadow-[0_0_16px_rgba(217,119,6,0.24)] sm:shadow-[0_0_80px_rgba(217,119,6,0.4)]" data-id="element-734" data-mp="1u83c1kb34i2b">
            {/* Decorative top accent */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-735" data-mp="1ghrhler12780"></div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 4.3
          }} className="text-center mb-6 sm:mb-8" data-id="element-736" data-mp="1bjybsmtmzf89">
              <div className="inline-block px-4 sm:px-8 py-2 sm:py-3 bg-gradient-to-r from-amber-600/20 via-amber-500/30 to-amber-600/20 border-2 border-amber-500/60 rounded-lg" data-id="element-737" data-mp="3pculo5y2jdov">
                <p className="text-amber-300 text-lg sm:text-xl md:text-2xl font-bold tracking-wide" style={{
                textShadow: '0 0 20px rgba(252, 211, 77, 0.5)'
              }} data-id="element-738" data-mp="2xlwx9e2qif97">
                  PSI PRO — MONTH-TO-MONTH MEMBERSHIP
                </p>
              </div>
            </motion.div>

            {/* Celebratory Trophy Animation - Moved below offer box */}

            {/* Updated headline */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 4.5
          }} className="mt-4 sm:mt-6 mb-8 sm:mb-10" data-id="element-739" data-mp="lygtpt54iquy"></motion.div>

            {/* Divider */}
            <div className="flex items-center justify-center gap-4 my-8 sm:my-10" data-id="element-740" data-mp="d9tcer66fcze">
              <div className="w-16 sm:w-24 h-px bg-gradient-to-r from-transparent via-amber-500 to-amber-500" data-id="element-741" data-mp="d7gjjiyvri7k" />
              <div className="w-3 h-3 bg-amber-500 rotate-45" data-id="element-742" data-mp="3bnawaoa88v2" />
              <div className="w-16 sm:w-24 h-px bg-gradient-to-l from-transparent via-amber-500 to-amber-500" data-id="element-743" data-mp="3c5clmtprfad" />
            </div>

            {/* WHO THIS IS FOR Section */}
            <div className="mb-8 sm:mb-10" data-id="element-744" data-mp="1xomv6h3lxr8o">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.6,
              delay: 5.2
            }} className="text-center mb-6 sm:mb-8" data-id="element-745" data-mp="1xnk345ujtir6">
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-amber-400 mb-4" style={{
                textShadow: '0 0 30px rgba(251, 191, 36, 0.4)'
              }} data-id="element-746" data-mp="28648nyc76voc">
                  👥 WHO THIS IS FOR
                </h3>
                <div className="w-32 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent mx-auto" data-id="element-747" data-mp="1k8f4v5o6bafm" />
              </motion.div>

              <div className="space-y-6 max-w-3xl mx-auto text-stone-300 mb-8 sm:mb-10" data-id="element-748" data-mp="1p81k1knkb0r2">
                <p className="text-base sm:text-lg text-center" data-id="element-749" data-mp="3en7veqa79b0p">
                  Three groups:
                </p>

                <div className="space-y-4 sm:space-y-6" data-id="element-750" data-mp="3jkrec3huebyz">
                  <div className="p-4 sm:p-6 bg-cyan-950/20 border-l-4 border-cyan-500 rounded-r-lg" data-id="element-751" data-mp="3toojo18046ys">
                    <p className="font-bold text-lg sm:text-xl text-cyan-300 mb-2 sm:mb-3" data-id="element-752" data-mp="3oqwfo8u30ue8">
                      1) Intelligent Biohackers
                    </p>
                    <p className="text-stone-300 text-sm sm:text-base" data-id="element-753" data-mp="6dyp2sj6jdwq">
                      For those who want total mastery over their own biology
                      (and the ability to help others with their health &
                      performance). Peptide Mastery 2.0, the monthly content and
                      the Q&A sessions can help you gain biological superpowers.
                    </p>
                  </div>

                  <div className="p-4 sm:p-6 bg-emerald-950/20 border-l-4 border-emerald-500 rounded-r-lg" data-id="element-754" data-mp="l94tjb2mn4ny">
                    <p className="font-bold text-lg sm:text-xl text-emerald-300 mb-2 sm:mb-3" data-id="element-755" data-mp="2r3e8h2g2k0cc">
                      2) Clinicians/Coaches/Practitioners
                    </p>
                    <p className="text-stone-300 text-sm sm:text-base" data-id="element-756" data-mp="129kazbrg89al">
                      For the professionals who want to be the "go-to" expert
                      and the ability to help almost ANYONE, even if everyone
                      else has failed. Peptide Mastery 2.0, the Q&A sessions,
                      Brenden's intel drops and particularly Dr. Ali's
                      diagnostics & medical work will take you to elite levels.
                    </p>
                  </div>

                  <div className="p-4 sm:p-6 bg-purple-950/20 border-l-4 border-purple-500 rounded-r-lg" data-id="element-757" data-mp="1ga3f47ssmv7h">
                    <p className="font-bold text-lg sm:text-xl text-purple-300 mb-2 sm:mb-3" data-id="element-758" data-mp="1uyr4fwc1q8oz">
                      3) Smart People Who Want Access to the Best
                    </p>
                    <p className="text-stone-300 text-sm sm:text-base" data-id="element-759" data-mp="23yw9w0xoix0i">
                      For those who simply want shortcuts to the best answers,
                      protocols, guidance and results whenever needed. Peptide
                      Mastery 2.0 with its masterful Dosing & Reference Sheet,
                      the 54 synergistic protocols, the modules covering every
                      part of the body, all the monthly content and the Q&A
                      sessions will allow you to find EXACTLY how get the best
                      results without needing to constantly study.
                    </p>
                  </div>
                </div>

                <div className="text-center space-y-3 sm:space-y-4 py-4 sm:py-6" data-id="element-760" data-mp="1ztk6mpc1czs7">
                  <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-761" data-mp="24o6g2myk4i9n">
                    We're looking for leaders who can lead themselves AND lead
                    others.
                  </p>
                  <p className="text-base sm:text-lg text-stone-300" data-id="element-762" data-mp="1utxqa70wv3f6">
                    People who are proactive, committed and take FULL
                    responsibility.
                  </p>
                  <p className="text-base sm:text-lg text-stone-300" data-id="element-763" data-mp="1lxotl04biiwq">
                    People who want to execute with certainty in a world full of
                    noise.
                  </p>
                  <p className="text-xl sm:text-2xl font-bold text-amber-400 mt-4 sm:mt-6" style={{
                  textShadow: '0 0 20px rgba(251, 191, 36, 0.4)'
                }} data-id="element-764" data-mp="3is893b9mr673">
                    This is the opportunity you've been waiting for.
                  </p>
                </div>
              </div>
            </div>

            {/* Divider - Added below "This is the opportunity you've been waiting for." */}
            <div className="flex items-center justify-center gap-4 my-8 sm:my-10" data-id="element-765" data-mp="1fnz8rs4stz5">
              <div className="w-16 sm:w-24 h-px bg-gradient-to-r from-transparent via-amber-500 to-amber-500" data-id="element-766" data-mp="3sjl0y2vfhwd4" />
              <div className="w-3 h-3 bg-amber-500 rotate-45" data-id="element-767" data-mp="2m1pk64jh9rcl" />
              <div className="w-16 sm:w-24 h-px bg-gradient-to-l from-transparent via-amber-500 to-amber-500" data-id="element-768" data-mp="2h3o3trdfs64t" />
            </div>

            {/* WHAT THIS IS Section */}
            <div className="mb-8 sm:mb-10" data-id="element-769" data-mp="11l88ftgf6pjy">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.6,
              delay: 5.15
            }} className="text-center mb-6 sm:mb-8" data-id="element-770" data-mp="11m9hxthsf3zk">
                <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-amber-400 mb-4 flex items-center justify-center gap-3" style={{
                textShadow: '0 0 30px rgba(251, 191, 36, 0.4)'
              }} data-id="element-771" data-mp="1kec2hfxjv4f3">
                  <span className="text-3xl sm:text-4xl" data-id="element-772" data-mp="3r4iar4l3bmxl">🧬</span> WHAT THIS IS
                </h3>
                <div className="w-32 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent mx-auto" data-id="element-773" data-mp="3v4kedjadyqfi" />
              </motion.div>

              <div className="space-y-6 max-w-3xl mx-auto text-stone-300" data-id="element-774" data-mp="2vssilqob6c1u">
                <p className="text-base sm:text-lg text-center" data-id="element-775" data-mp="2vuv7g7dq5z4z">
                  The Peptide Science Institute has created an{' '}
                  <span className="text-purple-400 font-bold" data-id="element-776" data-mp="34sxhfcffs24e">
                    elite, exclusive underground intelligence initiative.
                  </span>
                </p>

                <div className="p-4 sm:p-6 bg-purple-950/20 border-l-4 border-purple-500 rounded-r-lg" data-id="element-777" data-mp="2c4tbqqwv7p1p">
                  <p className="text-lg sm:text-xl font-bold text-purple-300 mb-2 sm:mb-3 text-center" data-id="element-778" data-mp="2qtxt65vu5p8r">
                    It's called the Private Research Order (PRO).
                  </p>
                  <p className="text-stone-300 text-center text-sm sm:text-base" data-id="element-779" data-mp="1ycv7ate3mhbv">
                    And we're looking for serious students and practitioners to
                    join us.
                  </p>
                </div>

                <div className="text-center space-y-3 sm:space-y-4 py-4 sm:py-6" data-id="element-780" data-mp="8uy9cmx4n2z9">
                  <p className="text-lg sm:text-xl" data-id="element-781" data-mp="dmzjo3aqijmn">
                    <span className="text-amber-400 font-bold" data-id="element-782" data-mp="dospjgdiwztl">
                      Our mission:
                    </span>{' '}
                    To empower members with the awe-inspiring ability to{' '}
                    <span className="font-bold text-white" data-id="element-783" data-mp="3uk57fyncd6i">
                      control human biology at the cellular level.
                    </span>
                  </p>
                  <p className="text-base sm:text-lg italic text-stone-400" data-id="element-784" data-mp="wksm74hg4rji">
                    Whether you want to heal, enhance performance, or optimize
                    at the highest levels.
                  </p>
                </div>

                <p className="text-xl sm:text-2xl font-bold text-white text-center" data-id="element-785" data-mp="33cbe2weqnxrb">
                  This is a complete intelligence immersion.
                </p>

                <p className="text-base sm:text-lg text-center" data-id="element-786" data-mp="3891qn9rc4b7z">
                  You get direct, ongoing access to the two masterminds who
                  decoded the peptide and biological matrix:
                </p>

                {/* Expert Cards - Side by Side */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6 sm:mt-8" data-id="element-787" data-mp="143jrjex1t7q3">
                  {/* Brenden Henry Card */}
                  <motion.div initial={{
                  opacity: 0,
                  x: -20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} transition={{
                  duration: 0.5,
                  delay: 5.3
                }} className="p-4 sm:p-6 bg-gradient-to-br from-cyan-950/20 to-black border-2 border-cyan-500/60 rounded-lg" data-id="element-788" data-mp="101or0cmxyydd">
                    <div className="flex justify-center mb-4" data-id="element-789" data-mp="2bietbko8v61p">
                      <div className="w-12 h-12 bg-cyan-500 rounded-full flex items-center justify-center" data-id="element-790" data-mp="2bgttbfj5uuwg">
                        <svg className="w-6 h-6 text-black" fill="currentColor" viewBox="0 0 20 20" data-id="element-791" data-mp="2a05h084g670">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-792" data-mp="b225ixea3kgr" />
                        </svg>
                      </div>
                    </div>
                    <h4 className="text-2xl font-bold text-cyan-300 mb-2 text-center" data-id="element-793" data-mp="3of3v8nbs5pmx">
                      Brenden Henry
                    </h4>
                    <p className="text-cyan-200 font-semibold text-center mb-4" data-id="element-794" data-mp="13qg2d9tmsaqq">
                      WORLD'S #1 PEPTIDE AUTHORITY
                    </p>
                    <ul className="space-y-2 text-sm text-stone-300" data-id="element-795" data-mp="fcb8z31wcust">
                      <li className="flex items-start gap-2" data-id="element-796" data-mp="agm6oryhszst">
                        <span className="text-cyan-400 mt-1" data-id="element-797" data-mp="o793gekp0fm9">•</span>
                        <span data-id="element-798" data-mp="o8k6uda87lcu">
                          <span className="font-bold text-cyan-300" data-id="element-799" data-mp="jfh8lrui7nqb">
                            First & ONLY person
                          </span>{' '}
                          to translate every original Russian peptide experiment
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-800" data-mp="175bokia4dses">
                        <span className="text-cyan-400 mt-1" data-id="element-801" data-mp="173hannx9n0k7">•</span>
                        <span data-id="element-802" data-mp="135b8yubabb65">
                          Creator of{' '}
                          <span className="font-semibold text-cyan-300" data-id="element-803" data-mp="38wexn34d2yx8">
                            Peptide Mastery 2.0
                          </span>{' '}
                          - the most advanced peptide education in history
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-804" data-mp="2ysrq3f5hofdo">
                        <span className="text-cyan-400 mt-1" data-id="element-805" data-mp="2yv47nr7c4nq7">•</span>
                        <span data-id="element-806" data-mp="2l0tpxttr9ttn">
                          Primary author of{' '}
                          <span className="italic text-cyan-300" data-id="element-807" data-mp="2pzwjah0dibls">
                            Peptide Salvation
                          </span>{' '}
                          - the world's biggest book on peptides
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-808" data-mp="222qxt65wvgrm">
                        <span className="text-cyan-400 mt-1" data-id="element-809" data-mp="224lhyi9cz4un">•</span>
                        <span data-id="element-810" data-mp="272vdwv2wq9hb">
                          Originator of the{' '}
                          <span className="font-semibold text-cyan-300" data-id="element-811" data-mp="aum9wjqu6wu">
                            Henry Cofactor Principle
                          </span>
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-812" data-mp="172wkpju1dzp7">
                        <span className="text-cyan-400 mt-1" data-id="element-813" data-mp="1c17s7nwuzy49">•</span>
                        <span data-id="element-814" data-mp="1c1hjrfxjydc2">
                          Identified the class of "super peptides" known as{' '}
                          <span className="font-semibold text-cyan-300" data-id="element-815" data-mp="1gy7ynzxmf2vw">
                            bioaugmentors
                          </span>
                        </span>
                      </li>
                    </ul>
                    <p className="text-cyan-300 font-bold text-center mt-4" data-id="element-816" data-mp="1urfrtw1co6fp">
                      No one else comes close.
                    </p>
                  </motion.div>

                  {/* Dr. Ali Mazloum Card */}
                  <motion.div initial={{
                  opacity: 0,
                  x: 20
                }} animate={{
                  opacity: 1,
                  x: 0
                }} transition={{
                  duration: 0.5,
                  delay: 5.4
                }} className="p-4 sm:p-6 bg-gradient-to-br from-emerald-950/20 to-black border-2 border-emerald-500/60 rounded-lg" data-id="element-817" data-mp="24ou5jnvw2h4b">
                    <div className="flex justify-center mb-4" data-id="element-818" data-mp="2erps0uysilbu">
                      <div className="w-12 h-12 bg-emerald-500 rounded-full flex items-center justify-center" data-id="element-819" data-mp="29w0m89w6g873">
                        <svg className="w-6 h-6 text-black" fill="currentColor" viewBox="0 0 20 20" data-id="element-820" data-mp="36kgeidqo8vnw">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-821" data-mp="2xigvjfw3jhib" />
                        </svg>
                      </div>
                    </div>
                    <h4 className="text-2xl font-bold text-emerald-300 mb-2 text-center" data-id="element-822" data-mp="1ioiko6m4o3ij">
                      Dr. Ali Mazloum
                    </h4>
                    <p className="text-emerald-200 font-semibold text-center mb-4" data-id="element-823" data-mp="19mj0x6jqalbw">
                      "THE HUMAN MRI"
                    </p>
                    <ul className="space-y-2 text-sm text-stone-300" data-id="element-824" data-mp="1ekatm2s76bh5">
                      <li className="flex items-start gap-2" data-id="element-825" data-mp="zw7n8sa8sxrt">
                        <span className="text-emerald-400 mt-1" data-id="element-826" data-mp="zuwjutkpls18">•</span>
                        <span data-id="element-827" data-mp="14p0qtctz602b">
                          <span className="font-bold text-emerald-300" data-id="element-828" data-mp="14pamnh1pb1fx">
                            Diagnostic genius
                          </span>{' '}
                          who spots what entire medical teams miss
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-829" data-mp="gyn7capgh9jc">
                        <span className="text-emerald-400 mt-1" data-id="element-830" data-mp="lvwv7lx75d52">•</span>
                        <span data-id="element-831" data-mp="2awmnbkh4thi">
                          Creates{' '}
                          <span className="font-semibold text-emerald-300" data-id="element-832" data-mp="2d95rs1yx9w5">
                            "impossible" transformations
                          </span>{' '}
                          that make specialists ask "how?"
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-833" data-mp="78y5bvdzmqsg">
                        <span className="text-emerald-400 mt-1" data-id="element-834" data-mp="l98y53yuyfg9">•</span>
                        <span data-id="element-835" data-mp="gb7g8md64m6d">
                          Often idolized by other medical specialists at his
                          hospital
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-836" data-mp="q10r1l5hkx9k">
                        <span className="text-emerald-400 mt-1" data-id="element-837" data-mp="q1iup2uhadri">•</span>
                        <span data-id="element-838" data-mp="141ju0dv3hd4v">
                          Head Transformation Specialist at the{' '}
                          <span className="font-semibold text-emerald-300" data-id="element-839" data-mp="10084078b6pw5">
                            Peptide Science Institute
                          </span>
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-840" data-mp="2yew497ufefbs">
                        <span className="text-emerald-400 mt-1" data-id="element-841" data-mp="33775ce0wk75x">•</span>
                        <span data-id="element-842" data-mp="386jz7iq6yei0">
                          Complete{' '}
                          <span className="font-semibold text-emerald-300" data-id="element-843" data-mp="388mpm3v9a9n9">
                            "full stack"
                          </span>{' '}
                          master of the human body
                        </span>
                      </li>
                    </ul>
                    <p className="text-emerald-300 font-bold text-center mt-4" data-id="element-844" data-mp="2kfed4ltnqpz9">
                      Any opportunity to learn from him is one you should take.
                    </p>
                  </motion.div>
                </div>

                <div className="text-center space-y-3 sm:space-y-4 py-4 sm:py-6 mt-6 sm:mt-8" data-id="element-845" data-mp="3sbroe59wx5v">
                  <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-846" data-mp="1oacw5fb6c2h6">
                    So, at this point you should realize...
                  </p>
                  <p className="text-base sm:text-lg text-stone-300" data-id="element-847" data-mp="1k9avqv5itkdm">
                    This isn't some random online course with videos for you to
                    forget about.
                  </p>
                  <p className="text-xl sm:text-2xl font-bold text-amber-400" style={{
                  textShadow: '0 0 20px rgba(251, 191, 36, 0.4)'
                }} data-id="element-848" data-mp="1aig57el8rymd">
                    This is an invitation to completely upgrade your life.
                  </p>
                  <p className="text-base sm:text-lg text-stone-300" data-id="element-849" data-mp="rk3nv5k6fifp">
                    With an elite, continual intelligence feed that evolves
                    with you month after month.
                  </p>
                  <p className="text-lg sm:text-xl font-bold text-white" data-id="element-850" data-mp="2lxldqz820rdw">
                    A living, breathing command center.
                  </p>
                </div>
              </div>
            </div>

            {/* Divider before Where you get */}
            <div className="flex items-center justify-center gap-4 my-8 sm:my-10" data-id="element-851" data-mp="39vkpv7z8cl1p">
              <div className="w-16 sm:w-24 h-px bg-gradient-to-r from-transparent via-amber-500 to-amber-500" data-id="element-852" data-mp="2w3mj33szr18p" />
              <div className="w-3 h-3 bg-amber-500 rotate-45" data-id="element-853" data-mp="30z1y3z2qj36p" />
              <div className="w-16 sm:w-24 h-px bg-gradient-to-l from-transparent via-amber-500 to-amber-500" data-id="element-854" data-mp="3ors8i3uzpeev" />
            </div>

            {/* WHERE YOU GET Section - Redesigned for visual flow */}
            <div className="mb-8 sm:mb-10" data-id="element-855" data-mp="3erhw2lgs4b0r">
              <div className="text-center mb-6 sm:mb-8" data-id="element-856" data-mp="3eux81ff5p3xy">
                <p className="text-xl sm:text-2xl font-bold text-amber-400 mb-4" data-id="element-857" data-mp="3jqcjy1tlsprq">
                  Where you get:
                </p>
                <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent mx-auto" data-id="element-858" data-mp="23fqruem6y1jb" />
              </div>

              <div className="grid gap-4 sm:gap-6 max-w-4xl mx-auto" data-id="element-859" data-mp="20s6jkt5crrso">
                {/* Benefit 1 */}
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.5,
                delay: 5.3
              }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-cyan-950/20 to-transparent border-l-4 border-cyan-500 rounded-r-lg" data-id="element-860" data-mp="1vstmzgooj6cw">
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-cyan-500 rounded-full flex items-center justify-center text-black font-bold text-sm sm:text-base" data-id="element-861" data-mp="1qwv1q1yne4gp">
                    1
                  </div>
                  <div data-id="element-862" data-mp="tfe8zar1psnd">
                    <p className="font-bold text-base sm:text-lg text-cyan-300 mb-1 sm:mb-2" data-id="element-863" data-mp="tg66ir47e0ga">
                      Direct, live access to Brenden Henry & Dr. Ali Mazloum
                      each month
                    </p>
                    <p className="text-stone-400 text-xs sm:text-sm" data-id="element-864" data-mp="cvob97v5uc0n">
                      The two people who literally wrote the book on peptides.
                      And who've reversed "irreversible" conditions more times
                      than I can count.
                    </p>
                  </div>
                </motion.div>

                {/* Benefit 2 */}
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.5,
                delay: 5.4
              }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-purple-950/20 to-transparent border-l-4 border-purple-500 rounded-r-lg" data-id="element-865" data-mp="vsyxnrvp1ayo">
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-purple-500 rounded-full flex items-center justify-center text-black font-bold text-sm sm:text-base" data-id="element-866" data-mp="2zxpch81u235l">
                    2
                  </div>
                  <div data-id="element-867" data-mp="2l31aw4zjzov9">
                    <p className="font-bold text-base sm:text-lg text-purple-300 mb-1 sm:mb-2" data-id="element-868" data-mp="2l3ujzclziqgk">
                      The Precision Cell™ Pro methodology
                    </p>
                    <p className="text-stone-400 text-xs sm:text-sm" data-id="element-869" data-mp="3drqafzkynm4w">
                      You'll get to learn the core transformation framework
                      Brenden, Ali and our team use to get incredible results
                      for our private clients – ones paying $15,000 to $120,000.
                    </p>
                  </div>
                </motion.div>

                {/* Benefit 3 */}
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.5,
                delay: 5.5
              }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-amber-950/20 to-transparent border-l-4 border-amber-500 rounded-r-lg" data-id="element-870" data-mp="kolaqx4itbq">
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-amber-500 rounded-full flex items-center justify-center text-black font-bold text-sm sm:text-base" data-id="element-871" data-mp="29ycxdwkfwphi">
                    3
                  </div>
                  <div data-id="element-872" data-mp="1w4vemdzkvgsj">
                    <p className="font-bold text-base sm:text-lg text-amber-300 mb-1 sm:mb-2" data-id="element-873" data-mp="1w5nc5ucqjolg">
                      The complete Peptide Mastery 2.0 program
                    </p>
                    <p className="text-stone-400 text-xs sm:text-sm" data-id="element-874" data-mp="2otswifzvnbkr">
                      130+ peptides. 54 of the most advanced multi-peptide
                      protocols ever created. 1,193 scientific citations. The
                      highest level and most complete peptide education in the
                      world. This alone deserves an hour-long video explaining
                      how powerful the information is. It is genuinely a
                      masterwork, included as a core part of your membership.
                    </p>
                  </div>
                </motion.div>

                {/* Benefit 4 */}
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.5,
                delay: 5.6
              }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-emerald-950/20 to-transparent border-l-4 border-emerald-500 rounded-r-lg" data-id="element-875" data-mp="3k1bmmwqqp7u3">
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-emerald-500 rounded-full flex items-center justify-center text-black font-bold text-sm sm:text-base" data-id="element-876" data-mp="1ypjdorcj1t7i">
                    4
                  </div>
                  <div className="text-center flex-1" data-id="element-877" data-mp="27ppmhzxa650c">
                    <p className="font-bold text-base sm:text-lg text-emerald-300 mb-1 sm:mb-2" data-id="element-878" data-mp="27o4sqcisiq3j">
                      Dr. Ali Mazloum's Strategic Briefings (LIVE)
                    </p>
                    <p className="text-stone-400 text-xs sm:text-sm" data-id="element-879" data-mp="2hfhhgv9al05c">
                      Hidden research. Field reports. Studies you won't find
                      anywhere else.
                    </p>
                  </div>
                </motion.div>

                {/* Benefit 5 */}
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.5,
                delay: 5.7
              }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-rose-950/20 to-transparent border-l-4 border-rose-500 rounded-r-lg" data-id="element-880" data-mp="111rdrpm34dw8">
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-rose-500 rounded-full flex items-center justify-center text-black font-bold text-sm sm:text-base" data-id="element-881" data-mp="2oyqvj1sqtn0q">
                    5
                  </div>
                  <div className="text-center flex-1" data-id="element-882" data-mp="2fznb9uhub1kn">
                    <p className="font-bold text-base sm:text-lg text-rose-300 mb-1 sm:mb-2" data-id="element-883" data-mp="2g0yb5j85zp6h">
                      Brenden Henry's Monthly Intelligence Drops
                    </p>
                    <p className="text-stone-400 text-xs sm:text-sm" data-id="element-884" data-mp="e54gvp3bzpsc">
                      New research drops. Protocol updates. Real-time
                      intelligence on what's working NOW.
                    </p>
                  </div>
                </motion.div>

                {/* Benefit 6 */}
                <motion.div initial={{
                opacity: 0,
                x: -20
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.5,
                delay: 5.8
              }} className="flex items-start gap-3 sm:gap-4 p-4 sm:p-6 bg-gradient-to-r from-blue-950/20 to-transparent border-l-4 border-blue-500 rounded-r-lg" data-id="element-885" data-mp="3kmmubmvxl7fc">
                  <div className="flex-shrink-0 w-6 h-6 sm:w-8 sm:h-8 bg-blue-500 rounded-full flex items-center justify-center text-black font-bold text-sm sm:text-base" data-id="element-886" data-mp="2s0ldhi2s0hfs">
                    6
                  </div>
                  <div className="text-center flex-1" data-id="element-887" data-mp="2j0f4a8e423mf">
                    <p className="font-bold text-base sm:text-lg text-blue-300 mb-1 sm:mb-2" data-id="element-888" data-mp="yhcwjoxfrg3y">
                      Questions & Answers Direct From the Masters (LIVE)
                    </p>
                    <p className="text-stone-400 text-xs sm:text-sm" data-id="element-889" data-mp="17hrjsttyn5a3">
                      Get YOUR specific questions answered. About YOUR
                      protocols. YOUR results. YOUR situation.
                    </p>
                  </div>
                </motion.div>
              </div>
            </div>

            {/* COSMIC TEXT SECTION - INSIDE OFFER BOX */}
            <div className="border-t-2 border-cyan-600/30 pt-8 sm:pt-10 mt-8 sm:mt-10" data-id="element-890" data-mp="jq41v1eof4jy">
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 1,
              delay: 6.05
            }} className="mb-8 sm:mb-10 max-w-5xl mx-auto relative" data-id="element-891" data-mp="opyr70iszm2w">
                {/* Dramatic spotlight behind text */}
                <div className="absolute inset-0 -inset-x-8 sm:-inset-x-32 bg-gradient-radial from-cyan-600/10 via-transparent to-transparent blur-2xl sm:blur-3xl" data-id="element-892" data-mp="3l40nwnuzlrlk" />

                {/* Cosmic background - NO BOX, just floating elements */}
                <div className="relative py-8 sm:py-12 px-2 sm:px-6 overflow-visible" data-id="element-893" data-mp="3tzgg70g3fyp1">
                  {/* Animated Stars - floating freely */}
                  <div className="absolute inset-0 -inset-x-6 sm:-inset-x-20 -inset-y-10 sm:-inset-y-20 overflow-visible pointer-events-none" data-id="element-894" data-mp="326zgkwdynfeg">
                    {[...Array(40)].map((_, i) => <motion.div key={i} className="absolute bg-cyan-300 rounded-full" style={{
                    width: Math.random() * 3 + 1 + 'px',
                    height: Math.random() * 3 + 1 + 'px',
                    top: Math.random() * 120 - 10 + '%',
                    left: Math.random() * 120 - 10 + '%',
                    boxShadow: '0 0 4px rgba(103, 232, 249, 0.6)'
                  }} animate={{
                    opacity: [0.2, 0.7, 0.2],
                    scale: [0.8, 1.3, 0.8]
                  }} transition={{
                    duration: Math.random() * 3 + 2,
                    repeat: Infinity,
                    ease: 'easeInOut',
                    delay: Math.random() * 2
                  }} data-id="element-895" data-mp="3b5kwejs1sgbj" data-mpi={i} />)}
                  </div>

                  {/* Constellation Lines - subtle connections */}
                  <svg className="absolute inset-0 w-full h-full pointer-events-none opacity-20 overflow-visible" data-id="element-896" data-mp="3b0ll24i33724">
                    <motion.path d="M100,30 L250,90 L400,50 L600,100" stroke="#22d3ee" strokeWidth="1" fill="none" initial={{
                    pathLength: 0,
                    opacity: 0
                  }} animate={{
                    pathLength: 1,
                    opacity: 0.3
                  }} transition={{
                    duration: 5,
                    ease: 'easeOut',
                    delay: 1
                  }} data-id="element-897" data-mp="3fsdf4p0g7ux0" />
                    <motion.path d="M50,100 L200,40 L350,110 L550,60" stroke="#67e8f9" strokeWidth="1" fill="none" initial={{
                    pathLength: 0,
                    opacity: 0
                  }} animate={{
                    pathLength: 1,
                    opacity: 0.25
                  }} transition={{
                    duration: 6,
                    ease: 'easeOut',
                    delay: 2
                  }} data-id="element-898" data-mp="1opqw0t8m9fsv" />
                  </svg>

                  {/* The Cosmic Text - NO BOX, bold font, floating in space */}
                  <div className="relative z-10 text-center space-y-4 sm:space-y-6" data-id="element-899" data-mp="2ypuznyk627ag">
                    <motion.p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold leading-relaxed" initial={{
                    opacity: 0
                  }} animate={{
                    opacity: 1
                  }} transition={{
                    duration: 2,
                    delay: 0.5
                  }} data-id="element-900" data-mp="33mtu6i7qsg96">
                      <span className="block text-cyan-200 font-extrabold" style={{
                      textShadow: '0 0 15px rgba(103, 232, 249, 0.5), 0 0 30px rgba(103, 232, 249, 0.3)'
                    }} data-id="element-901" data-mp="1n9mudpdcohv3">
                        Gain access to whole new worlds,
                      </span>
                      <span className="block mt-4 text-cyan-100 font-extrabold" style={{
                      textShadow: '0 0 18px rgba(34, 211, 238, 0.6), 0 0 35px rgba(34, 211, 238, 0.4)'
                    }} data-id="element-902" data-mp="13w3hqcro33au">
                        different dimensions of thinking,
                      </span>
                      <span className="block mt-4 text-white font-extrabold" style={{
                      textShadow: '0 0 20px rgba(255, 255, 255, 0.5), 0 0 40px rgba(103, 232, 249, 0.4)'
                    }} data-id="element-903" data-mp="1mk8kpi0i2k8l">
                        and new paradigms for medicine,
                      </span>
                      <span className="block mt-4 text-cyan-200 font-extrabold" style={{
                      textShadow: '0 0 15px rgba(103, 232, 249, 0.5), 0 0 30px rgba(103, 232, 249, 0.3)'
                    }} data-id="element-904" data-mp="3uvreso7y3lw6">
                        biology and peptides
                      </span>
                    </motion.p>
                  </div>

                  {/* Shooting Stars - multiple for more cosmic feel */}
                  <motion.div className="absolute top-10 left-0 h-px w-32 bg-gradient-to-r from-transparent via-cyan-300 to-transparent" style={{
                  rotate: '25deg',
                  filter: 'drop-shadow(0 0 8px #22d3ee)'
                }} animate={{
                  x: ['-100%', '400%'],
                  y: ['-100%', '400%'],
                  opacity: [0, 1, 0]
                }} transition={{
                  duration: 2.5,
                  repeat: Infinity,
                  repeatDelay: 8,
                  ease: 'easeOut'
                }} data-id="element-905" data-mp="3m1msmi3raymz" />
                  <motion.div className="absolute bottom-20 right-0 h-px w-24 bg-gradient-to-r from-transparent via-cyan-400 to-transparent" style={{
                  rotate: '-30deg',
                  filter: 'drop-shadow(0 0 6px #67e8f9)'
                }} animate={{
                  x: ['100%', '-400%'],
                  y: ['100%', '-400%'],
                  opacity: [0, 1, 0]
                }} transition={{
                  duration: 3,
                  repeat: Infinity,
                  repeatDelay: 12,
                  ease: 'easeOut',
                  delay: 4
                }} data-id="element-906" data-mp="3030mbdzbqyx0" />
                </div>
              </motion.div>
            </div>

            {/* BUT MAKE SURE YOU UNDERSTAND Section - MOVED HERE */}

            {/* OR IF YOU'RE READY Section */}
            <div className="border-t-2 border-green-600/30 pt-8 sm:pt-10 mt-8 sm:mt-10" data-id="element-907" data-mp="1z2kx6q5fef2z">
              {/* Elizabeth M. Testimonial */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 6.25
            }} className="relative mb-16" data-id="element-908" data-mp="1q3g1rsp5v1v1">
                {/* Subtle background glow - purple tint */}
                <div className="absolute inset-0 bg-gradient-radial from-purple-600/5 via-transparent to-transparent blur-2xl" data-id="element-909" data-mp="3ahq1fyl7glop" />

                <div className="relative px-4 sm:px-8 py-8 sm:py-10" data-id="element-910" data-mp="3njbn6f2eknmu">
                  {/* Profile Image */}
                  <div className="flex justify-center mb-6" data-id="element-911" data-mp="38mugi155rx6m">
                    <div className="relative" data-id="element-912" data-mp="38oozh9wvdf82">
                      <div className="absolute inset-0 bg-purple-500/20 blur-xl rounded-full" data-id="element-913" data-mp="3dke2xoc0fg9n" />
                      <img src="https://cdn.magicpatterns.com/uploads/7z7kG6cfruhkmzvLk7oX76/image09.jpg" alt="Elizabeth M." className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-purple-500/40 shadow-[0_0_30px_rgba(168,85,247,0.3)]" data-id="element-914" data-mp="2ztr13nayda9c" />
                    </div>
                  </div>

                  {/* Large opening quote - purple */}
                  <div className="mb-6" data-id="element-915" data-mp="2kwqkofy7p1q6">
                    <span className="text-purple-500/40 text-7xl font-serif leading-none" data-id="element-916" data-mp="2kvp1fo71l8xd">
                      "
                    </span>
                  </div>

                  {/* TV Screen Frame around testimonial text */}
                  <div className="relative mb-6 sm:mb-8 max-w-3xl mx-auto" data-id="element-917" data-mp="1xbfyc6rggnd7">
                    {/* Outer purple glow */}
                    <div className="absolute -inset-2 sm:-inset-4 bg-purple-500/10 blur-lg sm:blur-xl rounded-lg" data-id="element-918" data-mp="26a1ejv9gfqat" />

                    {/* TV screen frame */}
                    <div className="relative border-2 border-purple-500/30 rounded-lg p-4 sm:p-6 bg-gradient-to-br from-purple-950/20 to-black/40 shadow-[0_0_20px_rgba(168,85,247,0.18),inset_0_0_20px_rgba(168,85,247,0.05)] sm:shadow-[0_0_30px_rgba(168,85,247,0.2),inset_0_0_20px_rgba(168,85,247,0.05)]" data-id="element-919" data-mp="2l5r3a160yhj8">
                      {/* Screen scanline effect (subtle) */}
                      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/5 to-transparent pointer-events-none rounded-lg" data-id="element-920" data-mp="33x0f4h39pidz" />

                      {/* Testimonial text - with emphasis on key phrases */}
                      <p className="text-stone-300 text-base sm:text-lg md:text-xl leading-relaxed relative z-10" data-id="element-921" data-mp="1wn5d6wcdsrmv">
                        I've seen Brenden dissect complex pharmacological
                        mechanisms and explain them in a way that makes sense to
                        both medical professionals and laypeople alike.
                        <br data-id="element-922" data-mp="2fc26oxzyfg41" />
                        <br data-id="element-923" data-mp="2faquc9sg101b" />
                        He's able to{' '}
                        <span className="text-amber-400 font-semibold" data-id="element-924" data-mp="2kan0aekpb1ji">
                          predict outcomes and potential applications that
                          others simply don't see.
                        </span>
                        <br data-id="element-925" data-mp="2taiaoh6fmsih" />
                        <br data-id="element-926" data-mp="2tas2mab1f9qt" />
                        He's not afraid to challenge conventional wisdom when
                        the science doesn't support it. In a field often clouded
                        by hype and misinformation,{' '}
                        <span className="text-white font-bold" data-id="element-927" data-mp="rejc2jii68sd">
                          Brenden's dedication to truth is refreshing and
                          invaluable.
                        </span>
                        <br data-id="element-928" data-mp="hngalglnvrsk" />
                        <br data-id="element-929" data-mp="horah5bzkfee" />
                        As the director of ReadyMed, I've worked with countless
                        physicians, hormone specialists, and pharmacists over
                        the years. But I can say without hesitation that{' '}
                        <span className="text-amber-400 font-semibold" data-id="element-930" data-mp="15dixliapy7kb">
                          Brenden Henry's knowledge of peptides, pharmacology,
                          and human biology is truly in a league of its own.
                        </span>
                      </p>
                    </div>
                  </div>

                  {/* Attribution with client type */}
                  <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-931" data-mp="3h2tp6qewe46v">
                    <div className="hidden sm:block h-px flex-1 bg-gradient-to-r from-purple-500/40 to-transparent" data-id="element-932" data-mp="1k2p6wmpv30du" />
                    <div className="text-center sm:text-right" data-id="element-933" data-mp="1p2biystyeal2">
                      <p className="text-purple-400 font-semibold text-lg mb-1" data-id="element-934" data-mp="1ozpej22d0b72">
                        Elizabeth M.
                      </p>
                      <p className="text-stone-500 text-sm" data-id="element-935" data-mp="1g0c1y0ixv6i4">
                        Director at ReadyMed, Peptide Mastery buyer
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>

            </div>

            {/* SOPHISTICATED PRICING SECTION WITH STRONG ANCHORS */}
            <div className="border-t-2 border-amber-600/30 pt-8 sm:pt-10 mt-8 sm:mt-10" data-id="element-936" data-mp="1u0mtz6vzir4v">
              {/* PRICING INTRO */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.8,
              delay: 6.5
            }} className="text-center mb-12 relative" data-id="element-937" data-mp="2mpkb36ogmhw1">
                {/* Dramatic glow effect */}
                <div className="absolute inset-0 bg-gradient-radial from-amber-600/20 via-transparent to-transparent blur-3xl" data-id="element-938" data-mp="3akdttnzz4nib" />

                <div className="relative space-y-4 sm:space-y-6" data-id="element-939" data-mp="35o5di7a1io9k">
                  {/* Main headline with intense emphasis */}
                  <motion.div animate={{
                  textShadow: ['0 0 40px rgba(251, 191, 36, 0.6)', '0 0 60px rgba(251, 191, 36, 0.9)', '0 0 40px rgba(251, 191, 36, 0.6)']
                }} transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} data-id="element-940" data-mp="2dv4zgwhgtypp">
                    <h3 className="text-2xl sm:text-4xl md:text-5xl font-bold text-amber-400 mb-3 sm:mb-4" data-id="element-941" data-mp="lgxoz8t1nkr4">
                      🔬 YOUR PSI PRO MEMBERSHIP
                    </h3>
                  </motion.div>

                  <div className="max-w-3xl mx-auto space-y-3 sm:space-y-4" data-id="element-942" data-mp="vfn08iqfq6ye">
                    <p className="text-xl sm:text-2xl md:text-3xl font-bold text-stone-100 leading-tight" data-id="element-943" data-mp="qi3lzitqlu6g">
                      The Most{' '}
                      <span className="text-amber-400" data-id="element-944" data-mp="2pdepmws3z2i">Comprehensive Offer</span>{' '}
                      We Make
                    </p>

                    <p className="text-lg sm:text-xl text-stone-300 leading-relaxed" data-id="element-945" data-mp="chsrm5t7xxgj">
                      We're opening the doors to our{' '}
                      <span className="font-bold text-stone-100" data-id="element-946" data-mp="7p9j3n9e1sil">
                        Private Research Order
                      </span>{' '}
                      — and looking for the{' '}
                      <span className="font-bold text-stone-100" data-id="element-947" data-mp="3b713afha9868">
                        absolute best people
                      </span>{' '}
                      to join us.
                    </p>

                    <p className="text-lg sm:text-xl font-bold text-stone-100" data-id="element-948" data-mp="1vha0frlv0rd1">
                      Join month to month for{' '}
                      <span className="text-green-400" data-id="element-949" data-mp="1lq5n0wbu1ekb">$249/month</span>{' '}
                      as Peptide Mastery 2.0 unlocks one module at a time.
                    </p>
                  </div>

                  {/* Celebratory Trophy Animation */}
                  <motion.div initial={{
                  opacity: 0,
                  scale: 0.8
                }} animate={{
                  opacity: 1,
                  scale: 1
                }} transition={{
                  duration: 0.6,
                  delay: 6.55
                }} className="my-8 flex justify-center" data-id="element-950" data-mp="2eeb5tdjbsthi">
                    <div className="relative w-48 h-32 md:w-64 md:h-40" data-id="element-951" data-mp="2vn3xobbmuk0w">
                      {/* Trophy/Award Icon */}
                      <motion.svg className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 md:w-24 md:h-24" viewBox="0 0 24 24" fill="none" animate={{
                      y: [0, -8, 0],
                      rotate: [0, 5, 0, -5, 0]
                    }} transition={{
                      duration: 3,
                      repeat: Infinity,
                      ease: 'easeInOut'
                    }} data-id="element-952" data-mp="2qpkkzful2fb2">
                        {/* Trophy base */}
                        <path d="M12 15C15.866 15 19 11.866 19 8V5H5V8C5 11.866 8.13401 15 12 15Z" fill="url(#trophy-gradient)" stroke="#f59e0b" strokeWidth="1.5" data-id="element-953" data-mp="18myab877g7b" />
                        {/* Trophy stem */}
                        <path d="M12 15V19M9 19H15M9 22H15" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" data-id="element-954" data-mp="8qba05z3ffua" />
                        {/* Trophy handles */}
                        <path d="M5 8H3C2.44772 8 2 7.55228 2 7V6C2 5.44772 2.44772 5 3 5H5" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" data-id="element-955" data-mp="3hxvw0ruz7nlg" />
                        <path d="M19 8H21C21.5523 8 22 7.55228 22 7V6C22 5.44772 21.5523 5 21 5H19" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" data-id="element-956" data-mp="3vwlsq6dvvl9a" />
                        <defs data-id="element-957" data-mp="2k2jhqiijcd1f">
                          <linearGradient id="trophy-gradient" x1="12" y1="5" x2="12" y2="15" data-id="element-958" data-mp="2k3unuozgdwvp">
                            <stop offset="0%" stopColor="#fbbf24" data-id="element-959" data-mp="2o4wq7eoo2p1w" />
                            <stop offset="100%" stopColor="#f59e0b" data-id="element-960" data-mp="2o6r6ugswnv06" />
                          </linearGradient>
                        </defs>
                      </motion.svg>

                      {/* Animated Confetti Particles */}
                      {[...Array(12)].map((_, i) => <motion.div key={i} className="absolute" style={{
                      left: '50%',
                      top: '50%',
                      width: i % 3 === 0 ? '8px' : '6px',
                      height: i % 3 === 0 ? '8px' : '6px'
                    }} animate={{
                      x: [0, Math.cos(i * Math.PI * 2 / 12) * 80],
                      y: [0, Math.sin(i * Math.PI * 2 / 12) * 60],
                      rotate: [0, 360],
                      opacity: [1, 0]
                    }} transition={{
                      duration: 2,
                      repeat: Infinity,
                      delay: i * 0.1,
                      ease: 'easeOut'
                    }} data-id="element-961" data-mp="3bwbu3bw3def9" data-mpi={i}>
                          <div className={`w-full h-full rounded-full ${i % 4 === 0 ? 'bg-amber-400' : i % 4 === 1 ? 'bg-yellow-300' : i % 4 === 2 ? 'bg-amber-500' : 'bg-orange-400'}`} style={{
                        boxShadow: '0 0 8px currentColor'
                      }} data-id="element-962" data-mp="37rrgyvla0mpu" />
                        </motion.div>)}

                      {/* Sparkle Effects */}
                      {[...Array(6)].map((_, i) => <motion.div key={`sparkle-${i}`} className="absolute" style={{
                      left: `${20 + i * 15}%`,
                      top: `${30 + i % 2 * 20}%`
                    }} animate={{
                      scale: [0, 1, 0],
                      rotate: [0, 180],
                      opacity: [0, 1, 0]
                    }} transition={{
                      duration: 1.5,
                      repeat: Infinity,
                      delay: i * 0.3,
                      ease: 'easeInOut'
                    }} data-id="element-963" data-mp="14ftm80wwxvfi" data-mpi={i}>
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className="text-amber-400" data-id="element-964" data-mp="2r9b40e1g15b">
                            <path d="M8 0L9.5 6.5L16 8L9.5 9.5L8 16L6.5 9.5L0 8L6.5 6.5L8 0Z" fill="currentColor" data-id="element-965" data-mp="2nfsustbfdloo" />
                          </svg>
                        </motion.div>)}
                    </div>
                  </motion.div>

                  {/* Divider with emphasis */}
                  <div className="flex items-center justify-center gap-4 my-8" data-id="element-966" data-mp="368depl95cggc">
                    <div className="w-32 h-px bg-gradient-to-r from-transparent via-amber-500 to-amber-500" data-id="element-967" data-mp="3b53wqe4ihm4e" />
                    <div className="w-4 h-4 bg-amber-500 rotate-45 animate-pulse" data-id="element-968" data-mp="1bucjrbgpwdlj" />
                    <div className="w-32 h-px bg-gradient-to-l from-transparent via-amber-500 to-amber-500" data-id="element-969" data-mp="1grch8xzi4811" />
                  </div>

                  {/* WHAT'S INCLUDED Section */}
                  <motion.div initial={{
                  opacity: 0,
                  scale: 0.95
                }} animate={{
                  opacity: 1,
                  scale: 1
                }} transition={{
                  duration: 0.6,
                  delay: 5.9
                }} className="text-center mb-12" data-id="element-970" data-mp="3eom7xil5w2ew">
                    <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-amber-400 mb-4" style={{
                    textShadow: '0 0 30px rgba(251, 191, 36, 0.4)'
                  }} data-id="element-971" data-mp="2vrl2xxrly2ay">
                      📚 PEPTIDE MASTERY 2.0 IS INCLUDED
                    </h3>
                    <div className="w-32 h-1 bg-gradient-to-r from-transparent via-amber-500 to-transparent mx-auto mb-8" data-id="element-972" data-mp="jymjrw1jntcb" />

                    <div className="space-y-6 max-w-3xl mx-auto" data-id="element-973" data-mp="21vzmgc34284y">
                      <p className="text-lg font-bold text-stone-100 underline decoration-amber-400 decoration-2 underline-offset-4" data-id="element-974" data-mp="26xgjtxmdzcgs">
                        Every PSI PRO membership includes progressive access to
                        Peptide Mastery 2.0 — no separate purchase required.
                      </p>

                      <div className="p-6 bg-amber-950/30 border-2 border-amber-500/40 rounded-lg" data-id="element-975" data-mp="2lltkh7wf5jhm">
                        <p className="text-lg text-stone-300 mb-2" data-id="element-976" data-mp="2pmdhmbgzsn3r">
                          This is the most comprehensive peptide education ever
                          created.
                        </p>
                        <p className="text-2xl font-bold text-amber-400" data-id="element-977" data-mp="2gsqpqwfwo3zu">
                          One new module unlocks at a time.
                        </p>
                        <p className="text-stone-400 mt-2" data-id="element-978" data-mp="39b4fs9v02lod">
                          A separate option to fully unlock Peptide Mastery 2.0
                          will become available later.
                        </p>
                      </div>
                    </div>
                  </motion.div>

                  <p className="text-2xl font-bold text-amber-400" data-pricing-section data-id="element-979" data-mp="owd9ijbajx7g">
                    Start Your Monthly Membership:
                  </p>
                </div>
              </motion.div>

              <div className="max-w-xl mx-auto mb-8" data-id="element-980" data-mp="15g4zrlts268">
                {/* Monthly Membership */}
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.6,
                delay: 6.7
              }} className="relative p-6 sm:p-8 bg-gradient-to-br from-stone-900/60 to-black border-2 border-amber-500/60 rounded-xl shadow-[0_0_30px_rgba(217,119,6,0.2)] hover:shadow-[0_0_50px_rgba(217,119,6,0.4)] transition-all" data-id="element-981" data-mp="57kwokspqoq8">
                  <div className="text-center mb-6" data-id="element-982" data-mp="1lywwpn7jg6le">
                    <p className="text-cyan-400 font-semibold text-base sm:text-lg mb-2" data-id="element-983" data-mp="1lxlrdiyg2qs6">
                      Simple Month-to-Month Access
                    </p>
                    <h4 className="text-lg sm:text-xl md:text-2xl font-bold text-stone-100 mb-4 leading-tight" data-id="element-984" data-mp="1cztd8i4glp6d">
                      Peptide Mastery 2.0 + PSI PRO Membership
                    </h4>

                    <div className="mb-4" data-id="element-985" data-mp="131lze85gvn8l">
                      <p className="text-green-400 text-xs sm:text-sm font-bold mb-2" data-id="element-986" data-mp="yz8shgezhja8">
                        Your Price:
                      </p>
                      <div className="flex items-baseline justify-center gap-2" data-id="element-987" data-mp="2xdk7g6s1id2w">
                        <span className="text-4xl sm:text-5xl font-bold text-amber-400" data-id="element-988" data-mp="2td09x23k17g8">
                          $249
                        </span>
                        <span className="text-2xl text-stone-400" data-id="element-989" data-mp="qoi91j8qpno5">/mo</span>
                      </div>
                      <p className="text-stone-400 text-xs sm:text-sm mt-2" data-id="element-990" data-mp="vje8h4gb3dba">
                        Cancel anytime — no long-term contract
                      </p>
                    </div>
                  </div>

                  <ul className="space-y-3 mb-8" data-id="element-991" data-mp="19h2w2k1rcyk1">
                    <li className="flex items-start gap-3 text-sm text-stone-300" data-id="element-992" data-mp="19idzgirak4am">
                      <svg className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-993" data-mp="1ef4er3v9uvuz">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-994" data-mp="15dxucjpi50wg" />
                      </svg>
                      <span data-id="element-995" data-mp="3dn4e9yxfkwhj">
                        Peptide Mastery 2.0{' '}
                        <span className="font-semibold text-amber-300" data-id="element-996" data-mp="3dp71ycb42dj3">
                          modules unlocked monthly
                        </span>
                      </span>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-stone-300" data-id="element-997" data-mp="3mlpvnqr625gq">
                      <svg className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-998" data-mp="2yyhot4e3aocl">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-999" data-mp="38puhfy7ppijo" />
                      </svg>
                      <span data-id="element-1000" data-mp="1ei1ppvsra2k9">Ongoing PSI PRO membership, billed monthly</span>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-stone-300" data-id="element-1001" data-mp="1jfk25w5zezx0">
                      <svg className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-1002" data-mp="1ni6tlvyqqito">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1003" data-mp="1x6osg7ngmfuo" />
                      </svg>
                      <span data-id="element-1004" data-mp="2b6q2aclpcxma">All live sessions, bonuses, case studies</span>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-stone-300" data-id="element-1005" data-mp="ctpwy2orw5sn">
                      <svg className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20" data-id="element-1006" data-mp="gu09xzazfwh0">
                        <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-1007" data-mp="4h61eap5cxr6" />
                      </svg>
                      <span data-id="element-1008" data-mp="n98ljw0zyw66">
                        <span className="font-semibold text-green-400" data-id="element-1009" data-mp="nb1trfr9doga">
                          Learn at your own pace
                        </span>{' '}
                        as new modules unlock each month
                      </span>
                    </li>
                  </ul>

                  <a href="https://go.peptidescienceinstitute.com/pm-pro-monthly-fm" className="block w-full px-5 sm:px-6 py-4 sm:py-5 bg-gradient-to-r from-amber-600/80 to-amber-500/80 hover:from-amber-600 hover:to-amber-500 text-black text-center font-bold text-base md:text-lg rounded-lg transition-all duration-300 sm:hover:scale-105 min-h-[44px]" data-id="element-1010" data-mp="33zfcr5ihvssc">
                    Join Now — Unlock As You Go
                  </a>
                </motion.div>
              </div>

              {/* Michelle M.N. Testimonial */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 6.9
            }} className="relative mt-8" data-id="element-1011" data-mp="2hpgr06ksk8xu">
                {/* Subtle background glow - purple tint */}
                <div className="absolute inset-0 bg-gradient-radial from-purple-600/5 via-transparent to-transparent blur-2xl" data-id="element-1012" data-mp="1yt7f9pxd3uh0" />

                <div className="relative px-4 sm:px-8 py-8 sm:py-10" data-id="element-1013" data-mp="1k45qepv0w4nj">
                  {/* Profile Image */}
                  <div className="flex justify-center mb-6" data-id="element-1014" data-mp="1f5ufscwwlq49">
                    <div className="relative" data-id="element-1015" data-mp="1f7f8ry3kl100">
                      <div className="absolute inset-0 bg-purple-500/20 blur-xl rounded-full" data-id="element-1016" data-mp="1t5c8v4h8fpjf" />
                      <img src="https://cdn.magicpatterns.com/uploads/9qMkPazyxjG9vTCAeui9mc/MichelleMN.jpg" alt="Michelle M.N." className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-purple-500/40 shadow-[0_0_30px_rgba(168,85,247,0.3)]" data-id="element-1017" data-mp="1p38vubex0cw1" />
                    </div>
                  </div>

                  {/* Large opening quote - purple */}
                  <div className="mb-6" data-id="element-1018" data-mp="2ltrdqy6ngrh1">
                    <span className="text-purple-500/40 text-7xl font-serif leading-none" data-id="element-1019" data-mp="2lusw7npzwg8s">
                      "
                    </span>
                  </div>

                  {/* TV Screen Frame around testimonial text */}
                  <div className="relative mb-6 sm:mb-8 max-w-3xl mx-auto" data-id="element-1020" data-mp="3o987ar9asw5e">
                    {/* Outer purple glow */}
                    <div className="absolute -inset-2 sm:-inset-4 bg-purple-500/10 blur-lg sm:blur-xl rounded-lg" data-id="element-1021" data-mp="12ege1untgpk" />

                    {/* TV screen frame */}
                    <div className="relative border-2 border-purple-500/30 rounded-lg p-4 sm:p-6 bg-gradient-to-br from-purple-950/20 to-black/40 shadow-[0_0_20px_rgba(168,85,247,0.18),inset_0_0_20px_rgba(168,85,247,0.05)] sm:shadow-[0_0_30px_rgba(168,85,247,0.2),inset_0_0_20px_rgba(168,85,247,0.05)]" data-id="element-1022" data-mp="60zarkn8d663">
                      {/* Screen scanline effect (subtle) */}
                      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/5 to-transparent pointer-events-none rounded-lg" data-id="element-1023" data-mp="3j8anka8n3u1s" />

                      {/* Testimonial text - with emphasis on key phrases */}
                      <p className="text-stone-300 text-base sm:text-lg md:text-xl leading-relaxed relative z-10" data-id="element-1024" data-mp="2qpx1f7wo1wij">
                        I'm going through the peptide mastery and all the other
                        peptide courses and resources I've purchased from you
                        guys{' '}
                        <span className="text-amber-400 font-semibold" data-id="element-1025" data-mp="29c47q3um4iaf">
                          (I am LOVING it all!!)
                        </span>
                        ... I'm a functional medicine practitioner and{' '}
                        <span className="text-white font-bold" data-id="element-1026" data-mp="1vimlgbajkrgp">
                          I can't wait to incorporate some of these protocols
                          with my patients!!!
                        </span>
                      </p>
                    </div>
                  </div>

                  {/* Attribution with client type */}
                  <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-1027" data-mp="1hhk2i7eufxa0">
                    <div className="hidden sm:block h-px flex-1 bg-gradient-to-r from-purple-500/40 to-transparent" data-id="element-1028" data-mp="1cktkvfne4tmh" />
                    <div className="text-center sm:text-right" data-id="element-1029" data-mp="3v7n5jh8obisa">
                      <p className="text-purple-400 font-semibold text-lg mb-1" data-id="element-1030" data-mp="33uadggnqg0j">
                        Michelle M.N.
                      </p>
                      <p className="text-stone-500 text-sm" data-id="element-1031" data-mp="7vuihw6vsf87">
                        Doctor of Chiropractic & Certified Functional Medicine
                        Practitioner, Peptide Mastery buyer
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Tony R. Testimonial */}
              <motion.div initial={{
              opacity: 0,
              y: 30
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 7.1
            }} className="relative mt-16" data-id="element-1032" data-mp="3l9pfqpb61dxk">
                {/* Subtle background glow - purple tint */}
                <div className="absolute inset-0 bg-gradient-radial from-purple-600/5 via-transparent to-transparent blur-2xl" data-id="element-1033" data-mp="2q2q1p8n9vbuc" />

                <div className="relative px-4 sm:px-8 py-8 sm:py-10" data-id="element-1034" data-mp="2gakaw28rb0gq">
                  {/* Profile Image */}
                  <div className="flex justify-center mb-6" data-id="element-1035" data-mp="2baxvbm5gh84r">
                    <div className="relative" data-id="element-1036" data-mp="27ae04o4g0el9">
                      <div className="absolute inset-0 bg-purple-500/20 blur-xl rounded-full" data-id="element-1037" data-mp="27b5k11oognvp" />
                      <img src="https://cdn.magicpatterns.com/uploads/p7h6Y7wV2aZ8GFLXspCfFF/TonyR.jpg" alt="Tony R." className="relative w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-purple-500/40 shadow-[0_0_30px_rgba(168,85,247,0.3)]" data-id="element-1038" data-mp="22ahtsi89wb2j" />
                    </div>
                  </div>

                  {/* Large opening quote - purple */}
                  <div className="mb-6" data-id="element-1039" data-mp="1l28j2yxsl4w4">
                    <span className="text-purple-500/40 text-7xl font-serif leading-none" data-id="element-1040" data-mp="1l16wpybbsvz3">
                      "
                    </span>
                  </div>

                  {/* TV Screen Frame around testimonial text */}
                  <div className="relative mb-6 sm:mb-8 max-w-3xl mx-auto" data-id="element-1041" data-mp="1b1ptrongkw6t">
                    {/* Outer purple glow */}
                    <div className="absolute -inset-2 sm:-inset-4 bg-purple-500/10 blur-lg sm:blur-xl rounded-lg" data-id="element-1042" data-mp="23spwlwa1ztww" />

                    {/* TV screen frame */}
                    <div className="relative border-2 border-purple-500/30 rounded-lg p-4 sm:p-6 bg-gradient-to-br from-purple-950/20 to-black/40 shadow-[0_0_20px_rgba(168,85,247,0.18),inset_0_0_20px_rgba(168,85,247,0.05)] sm:shadow-[0_0_30px_rgba(168,85,247,0.2),inset_0_0_20px_rgba(168,85,247,0.05)]" data-id="element-1043" data-mp="28qrrdegudho7">
                      {/* Screen scanline effect (subtle) */}
                      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-500/5 to-transparent pointer-events-none rounded-lg" data-id="element-1044" data-mp="nf9iid3zbcsy" />

                      {/* Testimonial text - with emphasis on key phrases */}
                      <p className="text-stone-300 text-base sm:text-lg md:text-xl leading-relaxed relative z-10" data-id="element-1045" data-mp="avcmeaea1jfh">
                        I was honestly frustrated at first. All the questions,
                        testing and monitoring seemed excessive. But I
                        understand why it was so important. Everything gave you
                        information to fine-tune my program... What you have
                        managed to do is{' '}
                        <span className="text-amber-400 font-semibold" data-id="element-1046" data-mp="6v2cwnra0avv">
                          absolutely bonkers.
                        </span>{' '}
                        This is like a{' '}
                        <span className="text-white font-bold" data-id="element-1047" data-mp="3ai2g3qc2p5p8">
                          whole different planet of health optimization that
                          most people don't even know exists
                        </span>
                        ... I've gone from{' '}
                        <span className="text-amber-400 font-semibold" data-id="element-1048" data-mp="2ctprakz1whys">
                          thinking about my funeral to planning hiking trips.
                        </span>{' '}
                        I can't thank you guys and the team enough.
                      </p>
                    </div>
                  </div>

                  {/* Attribution with client type */}
                  <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-1049" data-mp="2whyiarouyhwp">
                    <div className="hidden sm:block h-px flex-1 bg-gradient-to-r from-purple-500/40 to-transparent" data-id="element-1050" data-mp="2wk1jm7vgnxgq" />
                    <div className="text-center sm:text-right" data-id="element-1051" data-mp="35imxvqtwgqbp">
                      <p className="text-purple-400 font-semibold text-lg mb-1" data-id="element-1052" data-mp="35i3ncv6kx47p">
                        Tony R.
                      </p>
                      <p className="text-stone-500 text-sm" data-id="element-1053" data-mp="1b4m2jfxk6lgd">
                        Transformation Services Client
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </motion.div>

        {/* TRANSITION SECTION - "WANT THE FULL DETAILS?" */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 6.9
      }} className="mt-12 sm:mt-20 mb-10 sm:mb-16 text-center max-w-3xl mx-auto" data-id="element-1054" data-mp="tvt6e5y7y8r6">
          {/* Scroll icon */}
          <motion.div className="flex justify-center mb-6" animate={{
          y: [0, 8, 0]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-1055" data-mp="1ckpzi6hvqv7t">
            <div className="w-12 h-12 rounded-full bg-amber-500/20 border-2 border-amber-500/40 flex items-center justify-center" data-id="element-1056" data-mp="3taexks80htqa">
              <svg className="w-6 h-6 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-1057" data-mp="3uslpmh8cemtb">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 13l-7 7-7-7m14-8l-7 7-7-7" data-id="element-1058" data-mp="3kt4li48qogzg" />
              </svg>
            </div>
          </motion.div>

          <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold text-amber-400 mb-4 sm:mb-6" style={{
          textShadow: '0 0 30px rgba(251, 191, 36, 0.4)'
        }} data-id="element-1059" data-mp="3gskmev4lv3ao">
            📜 WANT THE FULL DETAILS?
          </h3>

          <div className="space-y-3 sm:space-y-4 text-stone-300" data-id="element-1060" data-mp="2t2gmaxqmllof">
            <p className="text-lg sm:text-xl font-semibold" data-id="element-1061" data-mp="2t39wy9spgvbu">
              Keep reading below.
            </p>

            <p className="text-base sm:text-lg" data-id="element-1062" data-mp="2x667dd83dl4p">
              I'm going to walk you through EXACTLY what you're getting...
            </p>

            <p className="text-base sm:text-lg" data-id="element-1063" data-mp="29h7zar24tonk">
              Why this matters more now than ever...
            </p>

            <p className="text-base sm:text-lg font-bold text-amber-400" data-id="element-1064" data-mp="2nhirbxf6h9ab">
              And why this might be the most important decision you make all
              year.
            </p>
          </div>

          {/* Decorative divider */}
          <div className="flex items-center justify-center gap-4 mt-10" data-id="element-1065" data-mp="2xcj3cxkj79ie">
            <div className="w-32 h-px bg-gradient-to-r from-transparent via-amber-500 to-amber-500" data-id="element-1066" data-mp="2sf14k008aao4" />
            <div className="w-2 h-2 bg-amber-500 rounded-full" data-id="element-1067" data-mp="366fpwdhlynyc" />
            <div className="w-32 h-px bg-gradient-to-l from-transparent via-amber-500 to-amber-500" data-id="element-1068" data-mp="3253v7tjvncja" />
          </div>
        </motion.div>

        {/* Enhanced scroll indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 5.0
      }} className="mt-16" data-id="element-1069" data-mp="3b6aeubhtp3gr">
          <div className="flex flex-col items-center gap-3" data-id="element-1070" data-mp="qcvprkoy0wv0">
            <p className="text-amber-500 text-sm tracking-wider uppercase" data-id="element-1071" data-mp="vdic8z2bfk6c">
              Discover More
            </p>
            <motion.div className="w-px h-16 bg-gradient-to-b from-amber-600 to-transparent" animate={{
            opacity: [0.3, 1, 0.3]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-1072" data-mp="10bjr17spkxc0" />
            <motion.div animate={{
            y: [0, 10, 0]
          }} transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-1073" data-mp="he0j67hzlkr6">
              <ChevronDown className="w-6 h-6 text-amber-600" data-id="element-1074" data-mp="3l1iy7f1xj2dk" />
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}